import React, { Component } from 'react';
import { connect } from 'react-redux';
import { ForwardButton, BackButton, DisplayErrors } from "./Survey.jsx";
import AddLink from "./AddLink.jsx";
import AddFile from "./AddFile.jsx";
import { LoadingIcon } from '../../Common/Loading_Icon';

import axios from "axios";
import uuid from "uuidv4";

import { uploadS3 } from "../../../Helpers/uploadFile";
import { Trans } from 'react-i18next';

class FileUploadQuestion extends Component {
    constructor(props) {
        super(props);

        //Allows use of state and this in the handlechange function
        this.OnChangeHandler = this.OnChangeHandler.bind(this);
        this.localValidation = this.localValidation.bind(this);
        this.loadSurvey = this.loadSurvey.bind(this);
        this.addLink = this.addLink.bind(this);
        this.addFile = this.addFile.bind(this);
        this.removeArticle = this.removeArticle.bind(this);
        this.LinkChangeHandler = this.LinkChangeHandler.bind(this);
        this.triggerFile = this.triggerFile.bind(this);
        this.updateNextButton = this.updateNextButton.bind(this);

        var responses = [];
        var currentField = 1

        props.responses.some(function(item, index) {
            var new_response = {ID: currentField, Type: (((item.Answer).substring(0, 1) == "@") ? "File" : "Link"), Answer: item.Answer};
            currentField = (currentField + 1);
            responses.push(new_response);
        });

        this.state = {
            _validFileExtensions: [".jpg", ".jpeg", ".png", ".pdf"],
            currentField: currentField,
            maxField: 10,
            errors: [],
            responses: responses
        };
    }
    
    localValidation(e, props) {
        props.localValidation(e, props);
    }

    loadSurvey(e, props, action) {
        props.loadSurvey(e, props, action);
    }

    OnChangeHandler(e, props) {
        props.OnChangeHandler(e, props);
    }

    LinkChangeHandler(e, props) {
        var responses = this.state.responses;

        responses.some(function(item, index) {
            if(item.ID == props.response.ID) {
                item.Answer = e.target.value;
            }
        });

        this.setState({
            responses: responses
        });

        this.OnChangeHandler(e, this.props);
    }

    removeArticle(e, props) {
        var responses = this.state.responses;

        responses.some(function(item, index) {
            if(item.ID == props.response.ID) {
                responses.splice(index, 1);
            }
        });

        this.setState({
            responses: responses
        });

        this.updateNextButton(e, props);
    }

    updateNextButton(e, props) {
        var empty_fields_flag = true;
        var responses = this.state.responses;

        responses.some(function(item, index) {
            if(item.Answer != "")
            {
                empty_fields_flag = false;
                return;
            }
        });

        if($("#required").val() === "true" && empty_fields_flag) // check if question is required
        {
            $("#forward-button").toggleClass("disabled", true);
            $("#forward-button").css({'pointer-events': 'none', 'cursor': 'not-allowed;'});
        }
    }

    addLink(e, props) {
        var responses = this.state.responses;
        var currentField = (this.state.currentField + 1);
        var new_response = {ID: this.state.currentField, Type: "Link", Answer: ""};
        responses.push(new_response);

        this.setState({
            currentField: currentField,
            responses: responses
        });

    }

    triggerFile(id) {
        $('#' + id).click();
    }

    addFile(file) {
        var responses = this.state.responses;
        var currentField = (this.state.currentField + 1);
        var new_response = {ID: this.state.currentField, Type: "File", Answer: file};
        responses.push(new_response);

        this.setState({
            currentField: currentField,
            responses: responses
        });
    }

    uploadImage(id) {
        var filename = document.getElementById(id).value?.split(/(\\|\/)/g).pop()
        var original_filename = filename?.split(".")[0]
        var extension = filename?.split(".")[1].toLowerCase();
        var unique_id = uuid();
        var self = this;
        $('#loading-icon').show();
        $("#forward-button").toggleClass("disabled", true);
        $("#forward-button").css({'pointer-events': 'none', 'cursor': 'not-allowed;'});

        if (extension !== "jpg" && extension !== "jpeg" && extension !== "png" && extension !== "pdf" && extension !== "doc" && extension !== "docx") {
            $('#loading-icon').hide();
            $("#forward-button").toggleClass("disabled", false);
            $("#forward-button").css({'pointer-events': '', 'cursor': 'pointer'});
            showStatusMsg('Incorrect filetype for Vehicle Image. Please upload a .jpg, .jpeg, .png, .pdf, .doc or a .docx file', 'error');
        } else {
            uploadS3(document.getElementById(id).files[0], original_filename, extension, "/surveys", unique_id, function(response) {
                $('#loading-icon').hide();
                $("#forward-button").toggleClass("disabled", false);
                $("#forward-button").css({'pointer-events': '', 'cursor': 'pointer'});
                self.addFile(response);
            });
        }
    }
    
    render() {
        return (
            <div className="upload-question">
                <h3 className = "question-title">{ this.props.question.Text }</h3>
                <div className="body"></div>
                <div className="loading-wrapper" id='file-upload' alt='Loading' style={{display: 'none'}}>
                    <div className="lds-ring bkg-border-primary"><div></div><div></div><div></div><div></div></div>
                </div>
                    <div className="row collapse">
                        <div className="columns large-6 medium-6 small-12">
                            <a id="add-article-button" className="button add-link" onClick={(e) => this.addLink(e, this.props)}><Trans>Add Link</Trans></a>
                        </div>
                        <div className="columns large-6 medium-6 small-12">
                            <input id="files" type="file" name="files[]" style={{display: 'none'}} data-form-data='{"script": "true"}' />
                            <a id="upload-article-button" className="button upload-file" onClick={() => this.triggerFile('fileupload')}><Trans>Upload File</Trans></a>
                        </div>
                    </div>
                    <div className="field_wrapper">
                        { this.state.responses.map((response, index) =>
                            <div key={"Addlink_"+index}>
                                {
                                    response.Type == "Link" ?
                                        <AddLink response={response} removeArticle={this.removeArticle} LinkChangeHandler={this.LinkChangeHandler} />
                                    :
                                        <AddFile response={response} removeFile={this.removeArticle} />
                                }
                            </div>
                        ) }
                        <span id="loading-icon" style={{display: 'none'}}><LoadingIcon /></span>
                        <input type="file" id="fileupload" onChange={() => this.uploadImage("fileupload")} style={{display: 'none'}} accept=".pdf,.doc,.docx,.png,.jpg,.jpeg" /> 
                        <input type="text" name="file_upload" id="fileupload-files" style={{display: 'none'}}  />
                    </div>
                    <input type='hidden' name='question_id' id='question_id' value='{ this.props.question.Id }'/>
                    <input type='hidden' name='required' id='required' value={ (this.props.question.Validation).includes("required") ? true : false }/>
                    <DisplayErrors errors={this.props.errors} />
                <div className = "registration-buttons">
                    <div className="enable">
                        <a id='forward-button' onClick={(e) => this.localValidation(e, this.props)} className={ jQuery.isEmptyObject(this.props.responses) && (this.props.question.Validation).includes('required') ? 'button primary disabled' : 'button primary'}>
                            <i className="fas fa-long-arrow-alt-right"></i>
                        </a>
                    </div>

                    { this.props.question.question_orders.length == 0 || this.props.question.question_orders[0].Question_Order != 1 ?
                            <div className='back-btn'>
                                <a><i className="fas fa-long-arrow-alt-left" aria-hidden='true' onClick={(e) => this.loadSurvey(e, this.props, 'previous')}></i></a>
                            </div>
                        :
                            <span />
                    }


                    {/* <ForwardButton question={this.props.question} responses={this.props.responses} localValidation={this.localValidation} /> */}
                    {/* <BackButton question={this.props.question} /> */}
                </div>
            </div>
        );
    }
}


const mapStateToProps = store => ({
    userSession: store.userSession
})

export default connect(mapStateToProps,)(FileUploadQuestion);